import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface AppMockupFrameProps {
  variant?: 'light' | 'dark';
  title?: string;
  children: ReactNode;
  className?: string;
}

/**
 * AppMockupFrame
 * ウィンドウ枠コンポーネント（タイトルバー + 信号ボタン + コンテンツエリア）
 * Desktop/Webアプリのモックアップに使用
 */
export function AppMockupFrame({
  variant = 'light',
  title = 'Omokage',
  children,
  className,
}: AppMockupFrameProps) {
  const isDark = variant === 'dark';

  return (
    <div
      className={cn(
        'rounded-xl overflow-hidden border',
        isDark
          ? 'bg-[#141414] border-white/10 shadow-[0_60px_120px_rgba(0,0,0,0.5)]'
          : 'bg-background border-border shadow-[0_40px_100px_rgba(0,0,0,0.06)]',
        className
      )}
    >
      {/* Titlebar */}
      <div
        className={cn(
          'h-10 flex items-center px-4 gap-2 border-b',
          isDark ? 'bg-white/[0.03] border-white/[0.06]' : 'bg-background border-border'
        )}
      >
        {/* Traffic lights */}
        <div className="flex gap-2">
          <div
            className={cn(
              'w-2.5 h-2.5 rounded-full',
              isDark ? 'bg-[#FF5F57]/50' : 'bg-[#FF5F57]/40'
            )}
          />
          <div
            className={cn(
              'w-2.5 h-2.5 rounded-full',
              isDark ? 'bg-[#FEBC2E]/50' : 'bg-[#FEBC2E]/40'
            )}
          />
          <div
            className={cn(
              'w-2.5 h-2.5 rounded-full',
              isDark ? 'bg-[#28C840]/50' : 'bg-[#28C840]/40'
            )}
          />
        </div>
        {/* Title */}
        <span
          className={cn(
            'ml-3 text-xs font-medium',
            isDark ? 'text-white/40' : 'text-muted-foreground'
          )}
        >
          {title}
        </span>
      </div>
      {/* Content */}
      {children}
    </div>
  );
}
